import React from 'react';
import { useTranslation } from 'react-i18next';

const HowItWorks = () => {
  const { t } = useTranslation();

  const steps = [
    {
      number: '1',
      titleKey: 'howItWorks.step1.title',
      descKey: 'howItWorks.step1.description',
    },
    {
      number: '2',
      titleKey: 'howItWorks.step2.title',
      descKey: 'howItWorks.step2.description',
    },
    {
      number: '3',
      titleKey: 'howItWorks.step3.title',
      descKey: 'howItWorks.step3.description',
    },
  ];

  return (
    <section id="how-it-works" className="py-20 md:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="img-container">
              <img 
                src="/images/how-it-works.jpeg" 
                alt="How It Works" 
                className="w-full h-auto rounded-2xl"
              />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            {/* Section Header */}
            <div className="mb-10">
              <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                {t('howItWorks.title')}
              </h2>
              <p className="text-lg text-gray-600">
                {t('howItWorks.subtitle')}
              </p>
            </div>

            {/* Steps */}
            <div className="space-y-8">
              {steps.map((step, index) => (
                <div key={index} className="flex gap-5">
                  <div className="flex-shrink-0">
                    <div className="step-number">
                      {step.number}
                    </div>
                  </div>
                  
                  <div className="pt-1">
                    <h3 className="font-display text-lg font-semibold text-gray-900 mb-2">
                      {t(step.titleKey)}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {t(step.descKey)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
